import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { adminCustomersByIdReducers, adminCustomersByIdWatchers } from './_id';

export const adminCustomersReducers = combineReducers({
	byId: adminCustomersByIdReducers
});

export const adminCustomersWatchers = combineAllWatchers([
	adminCustomersByIdWatchers
]);
